<template>
  <v-main>
    <AppBar>
      <template #end>
        <v-btn icon plain @click="$router.go(-1)">
          <IconClose />
        </v-btn>
      </template>
    </AppBar>
    <v-form class="form-item fill-height" v-model="valid">
      <v-layout fill-height column>
        <v-container flex-fill class="py-0">
          <v-textarea
              v-model.lazy="inputVal"
              filled
              solo
              flat
              no-resize
              background-color="#fff"
              placeholder="오늘의 미션은 어떠셨나요?"
              counter="500"
              :rules="[rules.required, rules.trim, rules.length(500)]"
          />
          <!-- <div class="unit-info">
              <div class="title">유닛 제목</div>
              <v-switch
                  v-model="switch1"
                  inset
                  :ripple="false"
                  class="switch"
              ></v-switch>
          </div> -->
        </v-container>
        <div class="footer-btns vertical">
          <p class="fs-13">
            ※ 욕설 혹은 비방글을 남기면 운영 정책에 의해 서비스 이용이 제한될 수 있습니다.
          </p>
          <v-btn color="primary" class="btn-submit"
                 x-large depressed
                 :loading="isLoading"
                 :disabled="isLoading || !valid"
                 @click="setSquarePostRegist()">게시하기</v-btn>
        </div>
      </v-layout>
    </v-form>
  </v-main>
</template>
<script>
import store from '@/store'
import { mixinRemote, mixinReward } from '@/mixins'
import IconClose from '@/components/icons/Close'

export default {
  components: {
    IconClose
  },
  mixins: [ mixinRemote, mixinReward ],
  data: () => ({
    isLoading: false,
    valid: false,
    inputVal: null,
    // switch1: true,
    // switch2: false,
    unitUseNo: null,
    unitTitleExpsYn: 'N',
    // isRegist: false,
    rules: {
      required: v => !!v || '필수 값입니다.',
      trim: v => (!!v && v.trim() !== '') || '공백만 작성 할 수 없습니다.',
      length: len => v => (v || '').length <= len || `${len}자 미만으로 작성 할 수 있습니다.`,
    },
    freeYn: null,
    unitId: null
  }),
  created() {
    this.unitUseNo = this.$route.params.unitUseNo
    this.freeYn = this.$route.params.freeYn
    this.unitId = this.$route.params.unitId
    console.log("this.unitUseNo : ", this.unitUseNo)
    if (this.unitUseNo === null || this.unitUseNo === undefined
        || (this.unitId === null || this.unitId === undefined)
        || (this.freeYn === null || this.freeYn === undefined)) {
      this.$router.go(-1)
      return false
    }
  },
  methods: {
    async setSquarePostRegist() {
      if (this.isLoading) return
      this.isLoading = true

      // if(this.switch1){
      //     this.unitTitleExpsYn = 'Y'
      // }else{
      //     this.unitTitleExpsYn = 'N'
      // }
      let params = {
        searchCnt: 0,
        praiseCnt: 0,
        expsYn: 'Y',
        content: this.inputVal.trim(),
        unitNo: this.unitUseNo,
        unitTitleExpsYn: this.unitTitleExpsYn,
        unitId: this.unitId,
        freeYn: this.freeYn
      }
      await store.dispatch('setSquarePostRegist', this.$_payload('po', params))
          .then(res => {
            if (res.success) {

              this.insertMemberBadgePoss(2, 1)
              // this.$root.$children[0].$refs.content.$emit('insertMemberBadgePoss', 2, 1)
              this.insertMemberCoin(this.$store.state.auth.authUser.userKey, 2, '0007')
              // this.$root.$children[0].$refs.content.$emit('insertMemberCoin',this.$store.state.auth.authUser.userKey, 2, '0007')
              // setTimeout(() => this.$router.push({name: '메인', params: {'solutionComplete': true}}), 500);
              this.solutionComplete = true
              setTimeout(() => this.$router.go(-1), 500)

            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
            setTimeout(() => this.isLoading = false, 500)
          })
    },
  }
}
</script>
